// Umrlica.js
import React, { useEffect, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import axios from "axios";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import the styles
import {
  EmailShareButton,
  FacebookShareButton,
  TelegramShareButton,
  ViberShareButton,
  FacebookMessengerShareButton,
  WhatsappShareButton,
} from "react-share";
import {
  FacebookIcon,
  EmailIcon,
  FacebookMessengerIcon,
  TelegramIcon,
  ViberIcon,
  WhatsappIcon,
} from "react-share";
function SmallUmrlica({ post, modalIsOpen, userRole }) {
  const [imageSrc, setImageSrc] = useState(require("../assets/candle.png"));
  const [counter, setCounter] = useState(post.counter);

  const increaseCounter = async () => {
    try {
      await axios.post(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}/counter/up/`,
        {}
      );
      setCounter(post.counter + 1);
    } catch (error) {
      console.log("Error updating counter:", error);
    }
  };

  const deletePosts = async () => {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.delete(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  const handleCandleClick = () => {
    // Toggle between two image sources
    if (imageSrc === require("../assets/candle.png")) {
      setImageSrc(require("../assets/candleColor.png"));
    } else {
      setImageSrc(require("../assets/candle.png"));
    }
    increaseCounter();
  };

  const convertDate = (date) => {
    const [year, month, day] = date.split("-");
    return [day, month, year].join("/");
  };

  const modalStyle = {
    border: `5px solid ${
      post && post.color === "blue"
        ? "blue" // Use the specific color for "blue"
        : post.color === "green" ||
          post.color === "black" ||
          post.color === "red"
        ? post.color // Use other colors for "green," "black," or "red"
        : "black" // Default color for other cases
    }`,
    backgroundColor: "white",
    height: "320px",
    fontSize: "small",
  };
  return (
    <Container
      data-aos="fade-up"
      className="post"
      style={modalIsOpen ? { ...modalStyle, height: "auto" } : modalStyle}
    >
      <Row
        style={{
          fontStyle: "italic",
          border: "none",
          borderTop: "none",
          display: "flex",
          justifyContent: "end",
          paddingRight: "0.5rem",

          backgroundColor: "transparent",
          color: "gray",
          fontSize: "16px",
        }}
      >
        {post.type}
      </Row>
      <Row>
        <Col className="d-flex justify-content-around">
          {post.images.length !== 0 && (
            <Carousel
              showThumbs={false}
              showArrows={false}
              infiniteLoop={true}
              autoPlay={true}
              interval={2500}
              style={{ height: "fit-content" }}
            >
              {post.images
                .reduce((p, c) => p + c)
                .split(",")
                .map((imagePath, index) => (
                  <div className="d-flex justify-content-center" key={index}>
                    <div
                      style={{
                        width: "110px",
                        height: "130px",
                        border: "3px solid black",
                        background: `url(https://radojicictijanaa.pythonanywhere.com/${imagePath})`,
                        backgroundSize: "cover",
                        backgroundPosition: "50% 50%",
                      }}
                    ></div>
                  </div>
                ))}
            </Carousel>
          )}
        </Col>
      </Row>
      <Row
        className="d-flex justify-content-around"
        style={{
          fontWeight: "bold",
          letterSpacing: "1.2px",
          paddingTop: "2%",
        }}
      >
        {post.name}
      </Row>
      <Row
        style={{
          textAlign: "center",
          paddingLeft: "2%",
          paddingRight: "2%",
        }}
      >
        <span style={{ textAlign: "center" }}>
          {convertDate(post.birth_date)} - {convertDate(post.death_date)}
        </span>
      </Row>
      <Row style={{ paddingTop: "1%" }}>
        <span className="main-text">{post.main_text}</span>
      </Row>
      {modalIsOpen && (
        <Row>
          {" "}
          <span style={{ textAlign: "center" }}>Upali svijeću</span>
        </Row>
      )}
      {modalIsOpen && (
        <Row>
          {" "}
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              alignItems: "center",
              borderRadius: "100%",
            }}
            onClick={handleCandleClick}
          >
            <img src={imageSrc} alt="Image" />
          </button>
        </Row>
      )}
      {modalIsOpen && (
        <Row style={{ paddingBottom: "1%" }}>
          {" "}
          <span style={{ textAlign: "center" }}>{counter}</span>
        </Row>
      )}
      {modalIsOpen && (userRole === "admin" || userRole === "superadmin") && (
        <Col>
          <button className="btn btn-danger" onClick={() => deletePosts()}>
            Obriši
          </button>
        </Col>
      )}
      <Row style={{ padding: "2%", paddingLeft: "0" }}>
        <hr style={{ margin: "0", marginBottom: "1%" }}></hr>
        <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
          Ožalošćeni...
        </span>
        {modalIsOpen && (
          <p style={{ fontWeight: "bold", paddingTop: "1%" }}>
            {post.text_bottom}
          </p>
        )}
      </Row>{" "}
      {!modalIsOpen && (
        <div>
          <div className="predaj-pp-button">Predaj poslednji pozdrav</div>
        </div>
      )}
      {modalIsOpen && (
        <div
          style={{ float: "right", paddingBottom: "2%", paddingRight: "1%" }}
        >
          <FacebookShareButton
            title="Facebook"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
          >
            <FacebookIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </FacebookShareButton>
          <span title="Viber">
            <ViberShareButton
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <ViberIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </ViberShareButton>
          </span>
          <EmailShareButton
            title="Email"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            subject="Check out this post"
          >
            <EmailIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </EmailShareButton>
          <FacebookMessengerShareButton
            title="Messenger"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
          >
            <FacebookMessengerIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </FacebookMessengerShareButton>
          <span title="Telegram">
            <TelegramShareButton
              title="Telegram"
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <TelegramIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </TelegramShareButton>
          </span>
          <span title="What's App">
            <WhatsappShareButton
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
              title="Check out this post"
            >
              <WhatsappIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </WhatsappShareButton>
          </span>
        </div>
      )}
    </Container>
  );
}

export default SmallUmrlica;
